import { IAuthenticationProvider, AuthEnvironment, UIAuthProvider, CheckAndThrowCannotGetAuthContextError, GetAccessTokenOptions } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";
import { AuthErrors, AuthError } from './AuthErrors';
import { ErrorStringFromException } from "../../../utils/utils";
import { enableMsal5 } from "../../../utils/ChangeGate";

/*
    GCC stands for "GCC moderate environment".
*/
export class GCCAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {

        OfficeFirstPartyAuth.debugging = true;
        OfficeFirstPartyAuth.authorityOverride = "https://login.windows.net";
        if (enableMsal5) {
            (<any>OfficeFirstPartyAuth).useMsal5 = true;
        }

        try {
            this.authSharedComponent.Authenticate();
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToAuthenticate, ErrorStringFromException(error));
        }
    }

    async GetAccessToken(options: GetAccessTokenOptions): Promise<string> {
        try {
            return await this.authSharedComponent.GetAccessToken(options);
        } catch (error) {
            CheckAndThrowCannotGetAuthContextError(error);
            throw new AuthError(AuthErrors.UnableToFetchToken, ErrorStringFromException(error));
        }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.GCC;
    }

    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void {
        this.authSharedComponent.SetUIAuthProvider(uiAuthProvider);
    }
}